module.exports = __webpack_public_path__ + "img/demo.1647ea89.png";